/* [04] HIDDEN GARDEN LOCK
   Grails stay visible everywhere so people can see the piece, but they can only
   be unlocked in the garden. Cards keep their photo and click through to the
   product; the product page shows the photos and locks the buy area with an
   open, free patch of moss, like the garden is calling the piece back.
   Driven by window.__hglock = { url, handles } from theme.liquid. */
(function () {
  var CFG = window.__hglock || {};
  var HANDLES = CFG.handles || [];
  if (!HANDLES.length) return;
  var GARDEN = CFG.url || '/pages/hidden-garden';
  var LOCKED = {};
  HANDLES.forEach(function (h) { LOCKED[h] = true; });

  var LOCK_SVG = '<svg viewBox="0 0 24 24" aria-hidden="true"><rect x="5" y="11" width="14" height="9" rx="2"></rect><path d="M8 11V7.5a4 4 0 0 1 8 0V11"></path></svg>';
  // an irregular blob of moss, no straight edges, so it reads as a free stain
  var STAIN = 'radial-gradient(44% 38% at 32% 48%,#000 0%,#000 40%,rgba(0,0,0,.6) 62%,transparent 80%),radial-gradient(34% 42% at 58% 64%,#000 0%,rgba(0,0,0,.55) 46%,transparent 74%),radial-gradient(30% 30% at 46% 24%,#000 0%,transparent 72%),radial-gradient(26% 30% at 74% 42%,#000 0%,transparent 78%),radial-gradient(22% 26% at 20% 72%,#000 0%,transparent 76%)';

  function handleOf(href) {
    if (!href) return null;
    var m = href.match(/\/products\/([^/?#]+)/);
    return m ? m[1] : null;
  }

  // paint the site's moss onto a canvas. mode 'stain' turns it into a free,
  // irregular patch that bleeds past the box instead of a filled rectangle.
  function paintMoss(canvas, box, mode) {
    if (!window.Moss04Engine || !window.Moss04Engine.Layer) return;
    try {
      var E = window.Moss04Engine;
      E.setSeed(1 + Math.floor(Math.random() * 9999));
      var layer = new E.Layer(box, {
        canvas: canvas,
        lut: E.makeLUT(['', '', '', '', '']),
        size: mode === 'stain' ? 1.1 : 1.2,
        dir: 'up',
        anchor: 'bottom',
        height: function (full) { return full; },
        profile: mode === 'stain'
          ? function (t) { return 0.35 + 0.65 * E.ss(0, 1, t); }
          : function (t) { return t < 0.45 ? E.ss(0, 0.6, t) * 0.7 : 0.7 + 0.3 * E.ss(0.45, 1, t); }
      });
      layer.build();
      layer.paint(1, null);
      if (mode === 'stain') {
        // override the engine's own inline sizing so the moss spills out of the
        // panel as an organic, soft-edged stain rather than a boxed canvas
        var pw = box.offsetWidth || 360, ph = box.offsetHeight || 180;
        var sty = {
          position: 'absolute', right: 'auto', bottom: 'auto',
          left: '-' + Math.min(70, Math.round(pw * 0.17)) + 'px',
          top: '-32px',
          width: Math.round(pw * 1.3) + 'px',
          height: Math.round(ph + 130) + 'px',
          zIndex: '0', opacity: '.82', mixBlendMode: 'multiply',
          pointerEvents: 'none',
          WebkitMaskImage: STAIN, maskImage: STAIN,
          WebkitMaskComposite: 'source-over', maskComposite: 'add',
          WebkitMaskRepeat: 'no-repeat', maskRepeat: 'no-repeat'
        };
        for (var p in sty) canvas.style[p] = sty[p];
      }
    } catch (e) {}
  }

  // card: keep the photo and the click to the product, just add a small lock badge
  function badgeCard(link) {
    if (link.__hglk) return;
    var handle = handleOf(link.getAttribute('href'));
    if (!handle || !LOCKED[handle]) return;
    var card = link.closest('product-card, .product-card, .pg-card, .resource-card');
    if (!card) return;
    var box = card.querySelector('.card-gallery, .pg-media');
    var img = link.querySelector('img') || card.querySelector('img');
    if (!box && img) {
      box = img.parentElement.closest('.product-media-container, .product-media, picture, .ratio') || img.parentElement;
    }
    if (!box || !box.querySelector('img')) return;
    link.__hglk = true;
    if (box.querySelector('.hglk')) return;
    box.classList.add('hglk-host');
    box.dataset.hglkHandle = handle;
    var ov = document.createElement('span');
    ov.className = 'hglk';
    var cv = document.createElement('canvas');
    cv.className = 'hglk__moss';
    ov.appendChild(cv);
    box.appendChild(ov);
    var b = document.createElement('span');
    b.className = 'hglk-badge';
    b.innerHTML = LOCK_SVG + '<span>Locked</span>';
    box.appendChild(b);
    paintMoss(cv, ov);
  }

  function scan(root) {
    var links = (root || document).querySelectorAll('a[href*="/products/"]');
    for (var i = 0; i < links.length; i++) badgeCard(links[i]);
  }

  // find the buy area to replace. themes differ, so try the common shapes in
  // order and fall back to the spot right under the product title.
  function findBuyAnchor() {
    // 1) a real add-to-cart button that is not the sticky bar
    var all = document.querySelectorAll('button[name="add"]');
    var btn = null;
    for (var i = 0; i < all.length; i++) { if (!all[i].closest('sticky-add-to-cart')) { btn = all[i]; break; } }
    if (btn) {
      return btn.closest('add-to-cart-component, buy-buttons-component, [class*="buy-buttons"], form[action*="/cart/add"], .product-form, .group-block') || btn.parentElement;
    }
    // 2) a cart form on its own
    var form = document.querySelector('main#MainContent form[action*="/cart/add"], product-component form[action*="/cart/add"]');
    if (form) return form.closest('.group-block') || form;
    // 3) sold-out / notify grails use a Shopify Forms waitlist: lock its block
    var fe = document.querySelector('main#MainContent shopify-forms-embed, product-component shopify-forms-embed');
    if (fe) return fe.closest('.group-block, .shopify-app-block') || fe;
    // 4) fallback: just under the product title
    var title = document.querySelector('main#MainContent h1, product-component h1, .product-title, [class*="product-title"]');
    if (title) return title.nextElementSibling || title;
    return null;
  }

  function hideBuy(anchor) {
    if (anchor) anchor.style.display = 'none';
    var hide = document.querySelectorAll('main#MainContent shopify-forms-embed, product-component shopify-forms-embed, .shopify-payment-button, [data-shopify="payment-button"]');
    for (var k = 0; k < hide.length; k++) {
      var blk = hide[k].closest('.shopify-app-block, .shopify-block') || hide[k];
      blk.style.display = 'none';
    }
  }

  // product page of a grail: show the photos, drop a locked panel into the buy
  // area, and make sure the piece cannot be bought. returns true once placed.
  function lockProductPage() {
    if (document.querySelector('.hglk-buy')) return true;
    var anchor = findBuyAnchor();
    if (!anchor || !anchor.parentNode) return false;

    var panel = document.createElement('div');
    panel.className = 'hglk-buy';
    var cv = document.createElement('canvas');
    cv.className = 'hglk__moss';
    panel.appendChild(cv);
    panel.insertAdjacentHTML('beforeend',
      '<div class="hglk-buy__row"><span class="hglk-buy__ico">' + LOCK_SVG + '</span><p class="hglk-buy__h">This piece is locked</p></div>' +
      '<p class="hglk-buy__s">Part of the Hidden Garden. Make the [04] sign in nature and send the clip to unlock it for your account.</p>' +
      '<a class="hglk-buy__cta" href="' + GARDEN + '">Enter the garden</a>');
    var priceBlock = document.querySelector('main#MainContent product-price');
    anchor.parentNode.insertBefore(panel, anchor);
    if (priceBlock && !priceBlock.closest('product-card')) {
      priceBlock.classList.add('hglk-buy__price');
      panel.insertBefore(priceBlock, panel.querySelector('.hglk-buy__s'));
    }
    hideBuy(anchor === priceBlock ? null : anchor);
    paintMoss(cv, panel, 'stain');
    return true;
  }

  function boot() {
    scan(document);

    var m = location.pathname.match(/\/products\/([^/?#]+)/);
    var handle = m ? m[1] : null;
    var onLockedProduct = handle && LOCKED[handle];

    if (onLockedProduct) {
      // block any add-to-cart or express checkout on a locked grail
      document.addEventListener('click', function (e) {
        var t = e.target;
        if (t && t.closest && t.closest('button[name="add"], .add-to-cart-button, [class*="add-to-cart"] button, sticky-add-to-cart button, [class*="buy-buttons"] button, .shopify-payment-button, [data-shopify="payment-button"]')) {
          e.preventDefault();
          e.stopPropagation();
          if (e.stopImmediatePropagation) e.stopImmediatePropagation();
          window.location.href = GARDEN;
        }
      }, true);
      document.addEventListener('submit', function (e) {
        if (e.target && e.target.matches && e.target.matches('form[action*="/cart/add"]')) {
          e.preventDefault();
          e.stopPropagation();
        }
      }, true);

      // the buy area (sticky bar, waitlist app) can render late, so keep trying
      var placed = lockProductPage();
      if (!placed) {
        var tries = 0;
        var iv = setInterval(function () {
          tries++;
          if (lockProductPage() || tries > 25) clearInterval(iv);
        }, 300);
      }
    }

    // cards that load later: pagination, filters, predictive search, quick add,
    // home sections. also re-place the lock panel if a re-render removes it.
    if ('MutationObserver' in window) {
      var mo = new MutationObserver(function (muts) {
        for (var i = 0; i < muts.length; i++) {
          var added = muts[i].addedNodes;
          for (var j = 0; j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (n.matches && n.matches('a[href*="/products/"]')) badgeCard(n);
            if (n.querySelectorAll) scan(n);
          }
        }
        if (onLockedProduct && !document.querySelector('.hglk-buy')) lockProductPage();
      });
      mo.observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();